module.exports = __webpack_public_path__ + "static/img/logo.cab2be89.svg";